// Utility function to convert squared slider position to actual value
export const squaredToValue = (sliderPos, min, max) => {
    const normalized = sliderPos * sliderPos;
    return min + normalized * (max - min);
};

// Parse protocol messages from device
export const parseProtocolMessage = (line) => {
    if (line.length < 3) return null;

    const prefix = line[0];
    if (!'><#!'.includes(prefix)) return null;

    const colonIdx = line.indexOf(':', 1);
    if (colonIdx === -1) return null;

    const key = line.substring(1, colonIdx).trim();
    const value = line.substring(colonIdx + 1).trim();

    const typeMap = {
        '>': 'status',
        '<': 'command',
        '#': 'ack',
        '!': 'error'
    };

    return {
        type: typeMap[prefix],
        key,
        value
    };
};